import { InputProps, Select, VStack } from '@chakra-ui/react';
import { forwardRef, useMemo, useState } from 'react';
import { GoPerson } from 'react-icons/go';
import { Input, MaskedInput } from '../atoms/Input';

export const UsernameInput = forwardRef(function (props: InputProps & { noOptions?: boolean }, ref) {

  const { noOptions, ...rest } = props;
  const [inputType, setInputType] = useState<'email' | 'cpf' | 'cnpj'>('email');

  const mask = useMemo(() => {
    if (inputType === 'cpf') return '999.999.999-99';
    else if (inputType === 'cnpj') return '99.999.999/9999-99';

    return undefined;
  }, [inputType]);

  const _props = useMemo<InputProps>(
    () => ({
      minHeight: '42px',
      leftElement:
        noOptions
          ? null
          : (
            <VStack w={'120px'}>
              <Select
                variant={'unstyled'}
                borderColor={'#d4d4d4'}
                backgroundColor={'#f9f9f9'}
                left={'15px'}
                width={'70px'}
                height={'56px'}
                top="0px"
                position={'absolute'}
                borderRadius={'0px'}
                borderRight={'1px solid #d4d4d4'}
                onChange={(e) => setInputType(e.target.value as 'cpf' | 'cnpj' | 'email')}
                value={inputType}
                color="blackAlpha.700"
                fontWeight={'bold'}
                fontSize={'14px'}
              >
                <option value={'email'}>Email</option>
                <option value={'cpf'}>CPF</option>
                <option value={'cnpj'}>CNPJ</option>
              </Select>
            </VStack>
          ),
      rightElement: <GoPerson />,
    }),
    [inputType, props]
  );

  if (inputType === 'email' || noOptions) return <Input ref={ref} {..._props} {...rest} {... (noOptions ? { label: "Usuário" } : {})} />;

  return <MaskedInput mask={mask} ref={ref} {..._props} {...rest} />;
});
